import Track from 'core/logger/track';

class TrackSupport {
  faqOpened = (category: string, question: string) => {
    Track.getInstance().storeActionEvent('faqOpened', { category, question });
    Track.getInstance().ampEvent('faqOpened', { category, question });
  };

  sendFeedback = (name: string, email: string, message: string, cb: Function) => {
    if (message.length > 0 && message !== 'Message received :)' && message !== 'message sent :)') {
      const feedback = {
        name,
        email,
        message,
      };
      Track.getInstance()
        .sendFeedback(feedback)
        .then(() => cb())
        .catch(() => cb());
      Track.getInstance().ampEvent('submittedFeedback');
    }
  };
}

const supportTrack = new TrackSupport();
export default supportTrack;
